import React, { useEffect, useState } from 'react';
import { createTeam, anonymousSignIn, getTeamByName, addMemberToTeam, onAuthChange } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

export default function PlayerCreateTeam(){
  const [name, setName] = useState('');
  const [playerName, setPlayerName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(()=>{
    const unsub = onAuthChange(user => setCurrentUser(user));
    return unsub;
  }, []);

  useEffect(()=>{
    // If there's already an authenticated user, redirect to the player map —
    // the create/join page should only auto-redirect when the user is an anonymous player.
    // if an admin or other non-anonymous user is signed in, keep them on this page.
    if (currentUser && currentUser.isAnonymous) {
      navigate('/player/map');
    }
  }, [currentUser, navigate]);

  async function handleCreate(e){
    e.preventDefault();
    setError(null);
    const trimmed = (name || '').trim();
    const trimmedPlayer = (playerName || '').trim();
    if(!trimmed) {
      setError('Please enter a team name');
      return;
    }

    setLoading(true);
    try {
      // ensure the user has an auth identity and obtain uid
      // If there's already an authenticated user (e.g. admin), reuse it and avoid anonymous sign-in which would replace admin session.
      let user = currentUser;
      if (!user) {
        user = await anonymousSignIn();
      }
      const uid = user?.uid;

      // try to find existing team (case-insensitive match)
      const existing = await getTeamByName(trimmed);
      if (existing) {
        // add this user to the team's members (store name as well)
        if (uid) await addMemberToTeam(existing.id, uid, trimmedPlayer);
        // persist team selection locally so player pages don't need query param
        localStorage.setItem('teamId', existing.id);
        navigate('/player/team');
      } else {
        // create new team with this user as initial member (object)
        const id = await createTeam({ name: trimmed, initialMember: { uid, name: trimmedPlayer } });
        localStorage.setItem('teamId', id);
        navigate('/player/team');
      }
    } catch (err) {
      console.error('Failed to create/join team', err);
      setError(err.message || 'Unknown error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h3 className="card-title mb-3">{t('createOrJoinTeam')}</h3>
              <form onSubmit={handleCreate}>
                <div className="mb-3">
                  <input
                    className="form-control"
                    placeholder={t('teamName')}
                    value={name}
                    onChange={e=>setName(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className="mb-3">
                  <input
                    className="form-control"
                    placeholder={t('playerName')}
                    value={playerName}
                    onChange={e=>setPlayerName(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-primary" type="submit" disabled={loading || !name.trim()}>{loading ? t('processing') : t('joinOrCreate')}</button>
                </div>
              </form>
              {error && <div className="text-danger mt-2">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
